import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		content: {
			display: 'flex',
			justifyContent: ({ align }) => align || null,
		},
		button: {
			marginBottom: theme.spacing(1.75),
			color: theme.palette.text.secondary,
			'&:focus $text': {
				textDecoration: 'underline',
			},
			'& svg': {
				filter: ({ withShadow }) => (withShadow ? `drop-shadow(${theme.palette.textShadow})` : null),
			},
		},
		text: {
			textTransform: 'uppercase',
		},
	}),
	{ name: 'Questions-BackwardsAction' },
)

export default useStyles
